import { useEffect } from 'react';
import { useAuthStore } from '../context/AuthContext';
import { errorLoggingService } from '../services/errorLoggingService';

/**
 * Bridges the auth token to the singleton ErrorLoggingService.
 * Initialization of the service (baseUrl, endpoint, releaseId) is done
 * in AppRouter after settings/endpoints are fetched.
 * This component only syncs the auth token as it changes.
 */
export const useErrorLoggingInit = (): void => {
    const { token } = useAuthStore();

    useEffect(() => {
        errorLoggingService.setAccessToken(token || null);
    }, [token]);
};
